import { Component, OnInit, Input, ContentChild, TemplateRef } from '@angular/core';
import {ElementsService} from '../../elements.service'
import { TablesComponent } from '../tables.component';

@Component({
  selector: 'table-row',
  templateUrl: './table-item.component.html',
  styleUrls: ['./table-item.component.scss']
})
export class TableItemComponent implements OnInit {
  @Input() data: any;

  @ContentChild(TemplateRef,  {static: true}) templateVariable: TemplateRef<any>;
  
 // @ContentChild(TablesComponent,  {static: true}) table: TablesComponent;

  HTMLdata =[];

  constructor(private _elementService : ElementsService) { }

  ngOnInit() {

    this.HTMLdata = this.data;

    // this._elementService.getProcessedData().subscribe((d)=>{
    //   this.HTMLdata = d;
      
    // })

  }



  printTitle() {

    console.log("hello");
  }


}
